import React from 'react';

export const CollectIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="41.516"
    height="38.247"
    viewBox="0 0 41.516 38.247"
  >
    <g transform="translate(0)">
      <path
        d="M256.641,263.75H251a2.883,2.883,0,0,0-2.8,2.954v4.565a2.883,2.883,0,0,0,2.8,2.954h5.641a2.883,2.883,0,0,0,2.8-2.954V266.7A2.883,2.883,0,0,0,256.641,263.75Zm.763,7.519a.788.788,0,0,1-.763.806H251a.788.788,0,0,1-.763-.806V266.7A.788.788,0,0,1,251,265.9h5.641a.788.788,0,0,1,.763.806Z"
        transform="translate(-227.145 -242.921)"
        fill="currentColor"
      />
      <path
        d="M41.516,43.581a1.039,1.039,0,0,0-.136-.528L35.2,31.6a1.016,1.016,0,0,0-.882-.546H7.185A1,1,0,0,0,6.3,31.6L.136,43.053A1.132,1.132,0,0,0,0,43.581a6.3,6.3,0,0,0,3.563,5.746v18.9A1.05,1.05,0,0,0,4.581,69.3H36.927a1.05,1.05,0,0,0,1.018-1.074V49.462a.5.5,0,0,0-.008-.116A6.32,6.32,0,0,0,41.516,43.581ZM7.779,33.207h25.95l4.827,8.96H2.961Zm21.768,11.1a3.881,3.881,0,0,1-7.7,0Zm-9.866,0a3.976,3.976,0,0,1-3.851,3.4,3.991,3.991,0,0,1-3.86-3.4Zm-17.577,0H9.815a3.985,3.985,0,0,1-3.86,3.4A3.968,3.968,0,0,1,2.1,44.306Zm15,22.843H11.249V55.557A1.492,1.492,0,0,1,12.7,54.027H15.66a1.491,1.491,0,0,1,1.451,1.531V67.149Zm18.807,0H19.138V55.557a3.592,3.592,0,0,0-3.487-3.679H12.691A3.592,3.592,0,0,0,9.2,55.557v11.6H5.6v-17.3c.119.009.238.009.356.009a5.871,5.871,0,0,0,4.937-2.775,5.78,5.78,0,0,0,9.874,0,5.765,5.765,0,0,0,9.857,0,5.871,5.871,0,0,0,4.937,2.775c.119,0,.229-.009.348-.009V67.149Zm-.348-19.432a3.976,3.976,0,0,1-3.851-3.4h7.711A4,4,0,0,1,35.561,47.716Z"
        transform="translate(0 -31.05)"
        fill="currentColor"
      />
    </g>
  </svg>
);

export const DeliveryIcon = ({ className }) => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    width="28.234"
    height="29.79"
    viewBox="0 0 28.234 29.79"
  >
    <path
      d="M27.039.05.627,9.156A.983.983,0,0,0,.452,10.9l9.981,6.124a.871.871,0,0,0,1-.059l2.806-2.2-2.084,2.96a1,1,0,0,0-.056,1.056l5.8,10.532a.894.894,0,0,0,1.653-.185l8.63-27.868A.937.937,0,0,0,27.039.05ZM18.457,26.494l-4.48-8.13,5.4-7.676a1,1,0,0,0-.087-1.252A.876.876,0,0,0,18.1,9.344l-7.275,5.7L3.125,10.317,25.9,2.465ZM9.562,21.061,3.515,27.441a.877.877,0,0,1-1.288,0,1,1,0,0,1,0-1.359L8.274,19.7a.877.877,0,0,1,1.288,0A1,1,0,0,1,9.562,21.061ZM1.574,21.3a1,1,0,0,1,0-1.359L3.96,17.425a.877.877,0,0,1,1.288,0,1,1,0,0,1,0,1.359L2.862,21.3A.878.878,0,0,1,1.574,21.3ZM11.72,24.254a1,1,0,0,1,0,1.359L9.334,28.131a.884.884,0,0,1-.644.282.97.97,0,0,1-.644-1.64l2.386-2.518a.877.877,0,0,1,1.288,0Z"
      transform="translate(0 -0.001)"
      fill="currentColor"
    />
  </svg>
);
